import { Component, Input, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NzNotificationService } from 'ng-zorro-antd';
import { Services } from 'src/app/Models/servicemaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-sevicemaster',
  templateUrl: './sevicemaster.component.html',
  styleUrls: ['./sevicemaster.component.css']
})
export class SevicemasterComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: Services;
    isSpinning = false
  logtext:string = "";
  visi:boolean=true
  changes:boolean=false
  icons=''
  change(event:any)
  {
     this.visi=false
  this.changes=true
  this.icons=event
  }
  go(url:string)
  {
    this.visi=false
    window.open(url,"_blank")
  }
  
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
  };

  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

  this.logtext = 'CLOSED - Services form';
  // this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
  //   console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.TITLE == undefined || this.data.TITLE=="") {
      this.message.error("Please Enter Title" , "");
      isOk = false
    }
    
    if (this.data.DESCRIPTION == undefined || this.data.DESCRIPTION=="") {
      this.message.error("Please Enter Description" , "");
      isOk = false
    }
    if (this.data.ICON == undefined || this.data.ICON=="") {
      this.message.error("Please Enter Icon" , "");
      isOk = false
    }
    if (this.data.SEQUENCE_NO == undefined || this.data.SEQUENCE_NO==0) {
      this.message.error("Please Enter Sequence Number" , "");
      isOk = false
    }
    if(isOk)
    {
    
    
    

    this.isSpinning = true;
  
      if (this.data.ID) {

  

        this.api.updateServices(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Services information updated Successfully...", "");

  this.logtext = 'Update & Close - Services form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - Services ]";
  // this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
  //   console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

  this.logtext = 'Update & Close - Services form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - Services ]";
  // this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
  //   console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update services information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createServices(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Services information added successfully...", "");

              if (!addNew)
  {
                this.drawerClose();

  this.logtext = 'Save & Close - Services form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Services ]";
  // this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
  //   console.log(successCode);
  //           }
  //         });
  }

              else {
                this.data = new Services();
  this.logtext = 'Save & New - Services form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Services ]";
  // this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
  //   console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add services information...", "");
  this.isSpinning = false;
  this.logtext = 'Save & Close - Services form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - Services ]";
  // this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
  //   console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}